<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🧃</span>
            <span>Machines by Type</span>
        </h2>
        <apexchart class="flex justify-center items-center" type="donut" width="350" :options="chartOptions"
            :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: "VendingMachineByType",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'donut',
                },
                labels: [],
                colors: ['#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#7B6F9D'],
                legend: {
                    position: 'bottom',
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[opts.seriesIndex]
                    }
                }
            },
        };
    },
    watch: {
        data: {
            handler(newData) {

                if (!Array.isArray(newData)) return;

                const machinesByType = {};

                newData.forEach(vendor => {
                    vendor.machines.forEach(machine => {
                        const type = machine.type;
                        machinesByType[type] = (machinesByType[type] || 0) + 1;
                    });
                });

                const result = Object.entries(machinesByType).map(([type, count]) => ({
                    type,
                    count,
                }));

                const values = result.map(item => item.count);
                const labels = result.map(item => item.type);

                this.series = values;
                this.chartOptions = {
                    ...this.chartOptions,
                    labels: labels,
                    colors: this.chartOptions.colors.slice(0, labels.length),
                };
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>